<template lang="pug">
.mg-game__row
  PrizeItem.mg-game__row__prize(:prize="prize")

  .mg-game__row__cards.row
    template(v-if="showResult")
      transition(name="row", appear)
        .row__inner
          img.mg-game__row__result(:src="getResultImgSrc")
          button.mg-game__row__button(@click="claimReward")
            img(:src="getButtonImgSrc('reward')")
          button.mg-game__row__button(v-if="!hideUpgradeButton" @click="upgradeCards")
            img(:src="getButtonImgSrc('upgrade')")
    template(v-else)
      img.mg-game__row__card(v-for="index in getOpenedCardsRow", :key="index", :src="getCardImgSrc(index)")

  .mg-game__row__count(:class="getRowActiveClass") {{ openedCards }} / {{ MAX_CARDS_AMOUNT }}

</template>

<script>
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapGetters } = createNamespacedHelpers(mg_global);

import PrizeItem from "./../../common/PrizeItem.vue";

export default {
  name: "GameRow",

  components: { PrizeItem },

  props: {
    rowNumber: Number,
    prize: Object,
    openedCards: Number,
  },

  data() {
    return {
      MAX_CARDS_AMOUNT: 5,
      LAST_ROW: 5,
    };
  },

  computed: {
    ...mapGetters(["getSuperprizeLimit", "getSuperprizeClaimedAmount"]),

    getOpenedCardsRow() {
      return this.openedCards % this.MAX_CARDS_AMOUNT;
    },

    showResult() {
      return this.openedCards >= this.MAX_CARDS_AMOUNT;
    },

    isLastRow() {
      return this.rowNumber === this.LAST_ROW;
    },

    hideUpgradeButton() {
      return this.isLastRow && this.getSuperprizeClaimedAmount === this.getSuperprizeLimit;
    },

    getResultImgSrc() {
      return require(`@/assets/game/images/rows/row_${this.rowNumber}.png`);
    },

    getRowActiveClass() {
      return { "type--active": this.showResult };
    },
  },

  methods: {
    getCardImgSrc(index) {
      return require(`@/assets/game/images/cards/card_row${this.rowNumber}_${index}.png`);
    },

    getButtonImgSrc(button) {
      return require(`@/assets/game/images/${button}.svg`);
    },

    upgradeCards() {
      let reward_type = this.isLastRow ? "exchange_superprize" : "exchange_row";

      this.$store.commit(`${mg_global}/setCurrentRow`, this.rowNumber);
      this.$store.commit(`${mg_global}/setPopup`, reward_type);
    },

    claimReward() {
      this.$store.commit(`${mg_global}/setCurrentReward`, this.prize);
      this.$store.commit(`${mg_global}/setCurrentRow`, this.rowNumber);

      this.$store.commit(`${mg_global}/setPopup`, "reward_row");
    },
  },
};
</script>
